export default class SliderGallery {
  constructor(node) {
    this.node = node;

    // Function to check if the viewport is in mobile mode
    function isMobileViewport() {
      return window.innerWidth <= 768;
    }

    // Function to check if the viewport is in tablet mode
    function isTabletViewport() {
      return window.innerWidth >= 769 && window.innerWidth <= 1023;
    }

    // Initialize Swiper with appropriate settings based on viewport
    function initSwiper() {
      var swiperOptions = {
        effect: "coverflow",
        centeredSlides: true,
        slidesPerView: "auto",
        slideToClickedSlide: true,
        loop: true,
        speed: 500,
        grabCursor: true,
        pagination: {
          el: '.swiper-pagination',
          type: "fraction",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      };

      if (isMobileViewport()) {
        // Default coverflowEffect properties for mobile
        swiperOptions.coverflowEffect = {
          rotate: 0,
          stretch: -30,
          depth: 160,
          modifier: 1.15,
          slideShadows: false,
        };
      } else if (isTabletViewport()) {
          // Adjust coverflowEffect properties for tablet
          swiperOptions.coverflowEffect = {
            rotate: 0,
            stretch: -40,
            depth: 160,
            modifier: 1.15,
            slideShadows: false,
          };
      } else {
        // Default coverflowEffect properties for non-mobile
        swiperOptions.coverflowEffect = {
          rotate: 0,
          stretch: -200,
          depth: 455,
          modifier: 0.945,
          slideShadows: false,
        };
      }

      var swiper = new Swiper(".slider-gallery-list-wrapper.swiper-container", swiperOptions);
    }

    // Initialize Swiper
    initSwiper();

    // Listen for window resize event to reinitialize Swiper when viewport changes
    window.addEventListener('resize', function() {
      initSwiper();
    });

    function handleResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        initSwiper();
      }, 100);
    }
  }
}
